export const Container = ({ children }) => {
  return (
    <div className="mx-auto font-Comic font-semibold min-h-screen pb-20 bg-gradient-to-b from-blue-200 to-pink-200">
      {children}
    </div>
  );
};
